var App = App || {};

App.BlockCompare = (function ($) {
    'use strict';

    var Bps = ["xs", "sm", "md"],
        Bpm = ["md"],
        Bp = ZAGFramework.GetCurrentBP(),
        ColumnsAllowed = 2;

    function initStickyHeader(Component) {
        var contentEl = Component.find(".block-compare-content")[0];
        var compareTable = Component.find(".compare-table");
        var thead = compareTable.find(".thead");
        if (!thead.length) return;

        var theadTop, theadHeight, stickyStart, stickyEnd,
            reflowZoomMode = false,
            rafId = 0;

        function releaseSticky() {
            thead.removeClass('is-sticky').css({ 'transform': '' });
        }

        function measure() {
            releaseSticky();
            theadTop = thead.offset().top;
            theadHeight = thead.outerHeight(true);
            stickyStart = theadTop;
            stickyEnd = (compareTable.offset().top + compareTable.outerHeight()) - theadHeight;
        }

        // In WCAG reflow scenarios (commonly 400% zoom), the effective viewport
        // becomes very narrow. Disable sticky in this mode to avoid clipping/
        // misalignment issues and preserve predictable scrolling.
        function isReflowZoomMode() {
            var viewportWidth = Math.min(
                window.innerWidth || 0,
                document.documentElement.clientWidth || 0
            );
            var visualScale = (window.visualViewport && window.visualViewport.scale) || 1;

            // Use hysteresis to avoid rapid flip-flopping near threshold,
            // which can feel like "stuck" scrolling.
            if (!reflowZoomMode) {
                reflowZoomMode = viewportWidth <= 640 || visualScale > 1.25;
            } else {
                reflowZoomMode = !(viewportWidth >= 700 && visualScale <= 1.1);
            }

            return reflowZoomMode;
        }

        function updateSticky() {
            if (isReflowZoomMode()) {
                releaseSticky();
                return;
            }

            var scrollTop = $(window).scrollTop();
            var maxTranslate = Math.max(0, stickyEnd - stickyStart);
            var translateY = Math.min(Math.max(scrollTop - stickyStart, 0), maxTranslate);

            if (translateY <= 0) {
                releaseSticky();
                return;
            }

            // Keep thead in flow and move it vertically via transform.
            // This avoids layout jumps and end-boundary sticky thrashing.
            thead.addClass('is-sticky').css({
                'transform': 'translate3d(0,' + translateY + 'px,0)'
            });
        }

        function scheduleStickyUpdate() {
            if (rafId) return;
            var requestFrame = window.requestAnimationFrame || function (cb) { return window.setTimeout(cb, 16); };
            rafId = requestFrame(function () {
                rafId = 0;
                updateSticky();
            });
        }

        if (contentEl) {
            contentEl.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
        }

        // WCAG 2.4.11 Focus Not Obscured: if a focused element in the tbody is
        // behind the sticky header, scroll the page to reveal it.
        compareTable.on('focusin.compareSticky', function (e) {
            if (!thead.hasClass('is-sticky')) return;
            if ($(e.target).closest('.thead').length) return;
            var theadRect = thead[0].getBoundingClientRect();
            if (theadRect.bottom <= 0) return;
            var focusedRect = e.target.getBoundingClientRect();
            if (focusedRect.top < theadHeight + 8) {
                window.scrollBy(0, focusedRect.top - theadHeight - 8);
            }
        });

        measure();
        scheduleStickyUpdate();
        $(window).on('scroll.compareSticky', scheduleStickyUpdate);
        $(window).on('resize.compareSticky', function () {
            measure();
            scheduleStickyUpdate();
        });

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', function () {
                measure();
                scheduleStickyUpdate();
            }, { passive: true });
        }

        $(document).on('enter-xs enter-sm enter-md enter-lg enter-xl enter-xxl', function () {
            setTimeout(function () { measure(); scheduleStickyUpdate(); }, 100);
        });
    }

    function init() {

        $(".block-compare").each(function () {

            const Component = $(this);
            const Controls = Component.find(".block-compare-controls").length != 0;

            if (Controls) {
                CompareSetup(Component)
                $(document).bind("enter-xs enter-sm enter-md enter-lg enter-xl enter-xxl", function () { CompareSetup(Component) });
            } else {
                Component.find("[data-controlledby]:last-child").each(function () {
                    $(this).addClass("last-visible-column");
                });
            }

            initStickyHeader(Component);
        });

    }

    function CompareSetup(Component) {
        Bp = ZAGFramework.GetCurrentBP();
        var Controls = $(Component.find(".block-compare-controls")).find(".form-check-input");

        ColumnsAllowed = $(Controls).length;

        if (Bps.includes(Bp)) {
            if (Bpm.includes(Bp)) {
                if ($(Controls).length >= 3) { //allow up to 3 column comparison on tablet
                    ColumnsAllowed = 3;
                }
            }
            else if ($(Controls).length >= 2) { //allow up to 2 column comparison on mobile
                ColumnsAllowed = 2;
            }
        } else if ($(Controls).length >= 4) { //allow up to 4 columns above mobile
            ColumnsAllowed = 4;
        }

        Controls.prop("checked", false).attr("disabled", "disabled");
        for (var i = 0; i < ColumnsAllowed; i++) {
            $(Controls[i]).prop("checked", true).removeAttr("disabled");
        }

        CompareUpdate(Component);
        Controls.on("change", function () { CompareUpdate(Component); });
    }

    function CompareUpdate(Component) {

        var Controls = Component.find(".block-compare-controls"),
            ChartContent = Component.find(".block-compare-content"),
            ControlsChecked = [],
            ColumnsWidth = 0;

        Component.find(".columns-allowed-label").html(ColumnsAllowed)
        Controls.find(".form-check-input").each(function () {
            if ($(this).prop("checked")) {
                ControlsChecked.push($(this).attr("id"));
            }
        });

        //if allowed number of options are selected, disable the rest
        if (ControlsChecked.length >= ColumnsAllowed) {
            Controls.find(".form-check-input").each(function () {
                if (!$(this).prop("checked")) {
                    $(this).attr("disabled", "disabled");
                }
            });
        }
        else { //otherwise enable all
            Controls.find(".form-check-input").each(function () {
                $(this).removeAttr("disabled");
            });
        }

        //only show controls if chart is capable of exceding bounds
        if ($(Controls).find(".form-check-input").length > ColumnsAllowed) {
            Controls.removeClass("hide");

            //set aria-live text with updated status of compare chart
            if (ControlsChecked.length > 0) {
                var controlsAria = "Compare ";
                controlsAria += ControlsChecked.length;
                controlsAria += (ControlsChecked.length > 1 ? " columns: " : " column: ");

                var checkedTitles = "";
                for (var i = 0; i < ControlsChecked.length - 1; i++) {
                    checkedTitles += $('#' + ControlsChecked[i]).siblings(".form-check-label").text() + ", "
                }
                checkedTitles += $('#' + ControlsChecked[ControlsChecked.length - 1]).siblings(".form-check-label").text()
                controlsAria += checkedTitles;

                $(Controls).find(".controls-aria").text(controlsAria);
            }
            else {
                $(Controls).find(".controls-aria").text("No options selected. Select options to compare.");

                $(Controls).find(".controls-aria").text("");
            }

        } else {
            Controls.addClass("hide");
        }

        if (!ControlsChecked.length) {
            ChartContent.hide();
        }
        else {
            ChartContent.show();
            ColumnsWidth = 100 / ControlsChecked.length;
        }

        var lastVisibleColumn = ControlsChecked[ControlsChecked.length - 1];

        Component.find("[data-controlledby]").each(function () {

            var Control = $(this).attr("data-controlledby");

            if (ControlsChecked.includes(Control)) {
                $(this)
                    .css({width: ColumnsWidth + "%"})
                    .show();
            }
            else {
                $(this)
                    .removeAttr("style")
                    .hide();
            }

            //apply last visible column class
            if (Control == lastVisibleColumn) {
                $(this).addClass("last-visible-column");
            }
            else {
                $(this).removeClass("last-visible-column");
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlockCompare.init();
});